import React from 'react';
import classNames from 'classnames';
import { Box } from '@mui/material';

import CamPlaceholder from 'components/CamPlayerV2/CamPlaceholder';
import AspectRatioContent from 'components/CamPlayerV2/AspectRatioContent';
import type { Camera } from 'types/camera';

import { SpotDetails } from 'types/spot';
import styles from './CameraRewindsPlaceholder.module.scss';

const CameraRewindsPlaceholderWrapper = ({
  primaryCam,
  spot,
}: {
  primaryCam?: Camera;
  spot: SpotDetails | undefined;
}) => (
  <Box className={styles.wrapper}>
    <AspectRatioContent>
      <CamPlaceholder
        isDown={primaryCam?.status?.isDown}
        shouldLoad={!!primaryCam}
        stillUrl={primaryCam?.stillUrlFull}
      />
    </AspectRatioContent>
    <Box
      className={classNames(styles.controls, {
        [styles.controlsSmartRewinds]: primaryCam?.supportsSmartRewinds && spot?.insightsCameraId,
      })}
    >
      <Box className={styles.camControls} />
    </Box>
  </Box>
);

export default CameraRewindsPlaceholderWrapper;
